import { useLocalStorage } from "@/util/Storage";
import { useTranslation } from "react-i18next";

const useCustomTranslation = () => {
	const { t, i18n } = useTranslation();

	const changeLanguage = async (language: string) => {
		useLocalStorage.set("Language", language);
		await i18n.changeLanguage(language);
	};

	return { t, i18n, changeLanguage };
};

export default useCustomTranslation;
